import { Button, Group, Stack } from '@mantine/core';
import React from 'react';
import { DatePickerInput } from '@mantine/dates';
import { format } from 'date-fns';
import useCreateRemittanceInstruction from '../../../hooks/useCompleteRemittanceInstruction.ts';
import { RemittanceInstruction } from '../../../models/remittance-instruction.ts';
import { CompleteRemittanceInstructionRequest } from '../../../api/requests/complete-remittance-instruction-request.ts';

export default function RemittanceInstructionConfirmModal({
  remittanceInstruction,
  onSuccess,
}: {
  remittanceInstruction: RemittanceInstruction;
  onSuccess: () => void;
}) {
  const [selectedDate, setSelectedDate] = React.useState<string>(
    format(new Date(), 'yyyy-MM-dd'),
  );
  const { mutate: completeRemittanceInstruction, isPending } =
    useCreateRemittanceInstruction();

  return (
    <Stack>
      <DatePickerInput
        label="匯款日期"
        valueFormat="YYYY-M-DD"
        defaultValue={selectedDate}
        onChange={setSelectedDate}
        highlightToday={true}
      />
      <Group mt="md" justify="flex-end">
        <Button variant="outline" disabled={isPending}>
          取消
        </Button>
        <Button
          color="red"
          loading={isPending}
          onClick={() => {
            const request: CompleteRemittanceInstructionRequest = {
              id: remittanceInstruction.id,
              remittanceDateTime: selectedDate,
            };
            completeRemittanceInstruction(request, {
              onSuccess: onSuccess,
            });
          }}
        >
          是，我確認
        </Button>
      </Group>
    </Stack>
  );
}
